import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectThemePreference } from 'app/modules/theme/selectors';
import { updateThemePreference } from 'app/modules/theme/sliceTheme';
import { updateIntercomTheme } from 'app/shared/utils/intercom';

export const useSystemThemeListener = () => {
  const dispatch = useDispatch();
  const preference = useSelector(selectThemePreference);

  useEffect(() => {
    if (preference !== 'system') {
      return undefined;
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => {
      dispatch(updateThemePreference('system'));
    };

    mediaQuery.addEventListener('change', handler);
    return () => {
      mediaQuery.removeEventListener('change', handler);
    };
  }, [dispatch, preference]);

  useEffect(() => {
    if (window.Intercom !== undefined) {
      updateIntercomTheme(preference);
      return undefined;
    }

    // Intercom may not be initialized yet — poll until it's available
    const interval = setInterval(() => {
      if (window.Intercom !== undefined) {
        updateIntercomTheme(preference);
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [preference]);
};
